var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    { attrs: { width: "120", height: "30", viewBox: "0 0 120 30" } },
    [
      _c("circle", { attrs: { cx: "15", cy: "15", r: "15" } }, [
        _c("animate", {
          attrs: {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite",
          },
        }),
        _vm._v(" "),
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite",
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "circle",
        { attrs: { cx: "60", cy: "15", r: "9", "fill-opacity": "0.3" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "r",
              from: "9",
              to: "9",
              begin: "0s",
              dur: "0.8s",
              values: "9;15;9",
              calcMode: "linear",
              repeatCount: "indefinite",
            },
          }),
          _vm._v(" "),
          _c("animate", {
            attrs: {
              attributeName: "fill-opacity",
              from: "0.5",
              to: "0.5",
              begin: "0s",
              dur: "0.8s",
              values: ".5;1;.5",
              calcMode: "linear",
              repeatCount: "indefinite",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "105", cy: "15", r: "15" } }, [
        _c("animate", {
          attrs: {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite",
          },
        }),
        _vm._v(" "),
        _c("animate", {
          attrs: {
            attributeName: "fill-opacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }